import type { MainBannerV4 } from "~/core";

export const isMainBannerV4 = (item: unknown): item is MainBannerV4 => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "main_banner_v4"
  );
};
